import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { PrivacyPolicy, TermsOfService } from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Markets from "@/pages/Markets";
import Signals from "@/pages/Signals";
import PaperPositions from "@/pages/PaperPositions";
import TradeHistory from "@/pages/TradeHistory";
import Performance from "@/pages/Performance";
import Costs from "@/pages/Costs";
import CandleLogs from "@/pages/CandleLogs";
import DataHealth from "@/pages/DataHealth";
import Algorithm from "@/pages/Algorithm";
import Comparison from "@/pages/Comparison";
import MLModel from "@/pages/MLModel";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import LiveTrading from "@/pages/LiveTrading";
import ShadowRejected from "@/pages/ShadowRejected";
import Screener from "@/pages/Screener";
import ChatGPTExport from "@/pages/ChatGPTExport";
import MtfLab from "@/pages/MtfLab";

function AppRouter() {
  const location = useLocation();
  // Synchronous check for OAuth callback fragment — before ProtectedRoute runs
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Navigate to="/dashboard" replace />
          </ProtectedRoute>
        }
      />
      {[
        ["/dashboard", <Dashboard />],
        ["/markets", <Markets />],
        ["/signals", <Signals />],
        ["/positions", <PaperPositions />],
        ["/trades", <TradeHistory />],
        ["/performance", <Performance />],
        ["/costs", <Costs />],
        ["/candle-logs", <CandleLogs />],
        ["/data-health", <DataHealth />],
        ["/algorithm", <Algorithm />],
        ["/mtf-lab", <MtfLab />],
        ["/comparison", <Comparison />],
        ["/shadow-rejected", <ShadowRejected />],
        ["/screener", <Screener />],
        ["/chatgpt-export", <ChatGPTExport />],
        ["/ml", <MLModel />],
        ["/audit", <AuditLog />],
        ["/settings", <Settings />],
        ["/live", <LiveTrading />],
      ].map(([path, el]) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute>
              <Layout>{el}</Layout>
            </ProtectedRoute>
          }
        />
      ))}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
